export default defineNuxtRouteMiddleware(async () => {
  const nuxtApp = useNuxtApp()
  return nuxtApp.runWithContext(
    () => navigateTo('/404', { redirectCode: 301, replace: true })
  )
})
